import { lazy } from 'react';

const AdTags = {
  Helmet: lazy(() => import('./components/Helmet')),
  Layout: lazy(() => import('./containers/AdTags/components/AdTagsLayout')),
  Table: lazy(() => import('./containers/AdTags/containers/AdTagsTable')),
  ThirdPartyTagForm: lazy(() => import('./containers/AdTags/modules/ThirdPartyTagForm')),
  ThirdPartyWebsites: lazy(() => import('./containers/AdTags/containers/ThirdPartyWebsites')),
};

export default AdTags;
